import React from "react";
import { useParams } from "react-router-dom";
import {
  ReactFlow,
  MiniMap,
  useNodesState,
  useEdgesState,
  ConnectionLineType,
  useReactFlow,
} from "@xyflow/react";
import { useIntl } from "react-intl";
import CustomNode from "./CustomNode";
import {
  layoutTopology,
  transformPathsToTopology,
} from "../../utils/topologyUtils";
import Loader from "../Loader";
import { objectPathsShape } from "../../shapes/objectPathShape";
import { useLog, useNotifier } from "../../context";

type Props = {
  paths: objectPathsShape;
  onClose: $TSFixMeFunction;
};

function Topology({ paths, onClose }: Props) {
  const intl = useIntl();
  const log = useLog();
  const notifier = useNotifier();

  const topologyFittedRef = React.useRef(false);
  // @ts-expect-error TS(2339) FIXME: Property 'id' does not exist on type '{}'.
  const { id: objectId } = useParams();

  const onTopologyError = (error: $TSFixMe) => {
    log.error("Topology", error);
    notifier.showError(intl.formatMessage({ id: "layout_topology.error" }));
  };

  const { initialNodes, initialEdges } = React.useMemo(() => {
    try {
      return transformPathsToTopology(paths, objectId);
    } catch (error) {
      onTopologyError(error);
      return { initialNodes: [], initialEdges: [] };
    }
  }, [paths, objectId]);

  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges] = useEdgesState([]);

  const { fitView } = useReactFlow();

  const onLayout = React.useCallback(async () => {
    try {
      const topology = await layoutTopology(
        initialNodes,
        initialEdges,
        // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 3.
        onTopologyError,
      );
      // @ts-expect-error TS(2345) FIXME: Argument of type '{ position: { x: number | undefi... Remove this comment to see the full error message
      setNodes(topology.nodes);
      // @ts-expect-error TS(2345) FIXME: Argument of type 'ElkExtendedEdge[] | undefined' i... Remove this comment to see the full error message
      setEdges(topology.edges);
    } catch (error) {
      onTopologyError(error);
    }
  }, [initialNodes, initialEdges]);

  React.useLayoutEffect(() => {
    onLayout();
  }, []);

  const handleNodesChange = (n: $TSFixMe) => {
    onNodesChange(n);
    // So that the topology is fitted only once
    if (!topologyFittedRef.current) {
      fitView({ padding: 0.1 });
      topologyFittedRef.current = true;
    }
  };

  const isLoading = nodes.length === 0 || edges.length === 0;

  return (
    <dialog className="cyan-stripe" open>
      {!isLoading && (
        <ReactFlow
          nodes={nodes}
          edges={edges}
          nodeTypes={{ custom: CustomNode }}
          onNodesChange={handleNodesChange}
          nodesConnectable={false}
          connectionLineType={ConnectionLineType.Step}
          className="topology"
        >
          <MiniMap />
        </ReactFlow>
      )}
      <Loader id="topology-loader" loading={isLoading} />
      <button
        type="button"
        aria-label="close-topology-dialog"
        className="icon-eh-close"
        onClick={onClose}
      />
    </dialog>
  );
}

export default Topology;
